export default __webpack_public_path__ + "static/media/logo_mini.ac031c3b.png";